export const creditCardExpireDateFormatStrategy = (value: string) => {
  return !!value.match('^(0[1-9]|1[0-2])/([0-9]{2})$');
};
